import _ from 'underscore';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import React from 'react';

import i18next from "i18next"

export function analyseState(state) {

	
	

	const STATE_TABLE = {
		0: { label: 'unmarked', 'text': i18next.t('analyseState.uninitialized'), 'verif': false },
		1: { label: 'requested', 'text': i18next.t('analyseState.sms_send_request_received'), 'verif': true },
		2: { label: 'SMSSENT', 'text': i18next.t('analyseState.mcp_sended_sms'), 'verif': true },
		3: { label: 'ACKNOWLEDGE', 'text': i18next.t('analyseState.ftp_product_aquit'), 'verif': false },
		4: { label: 'ERRNOTME', 'text': i18next.t('analyseState.p_id_conflict_db'), 'verif': false },
		5: { label: 'ERRTIMEO', 'text': i18next.t('analyseState.p_not_aquit_timeout'), 'verif': false },
		6: { label: 'ERRSMS', 'text': i18next.t('analyseState.verify_info_id_gsm'), 'verif': false },
		7: { label: 'ERRPRESTA', 'text': i18next.t('analyseState.provider_ftp_error'), 'verif': false }
	}

	state = state != null ? state : 0;

	var binMask = "000";
	var binString = parseInt(state).toString(2);
	var octalList = (binMask.substring(0, 3 - (binString.length % 3)) + binString).match(/.{1,3}/g).reverse();

	var schema = ['asts1', 'asts0', 'aspr1', 'aspr0'];

	var result = {
		'asts1': { label: i18next.t('analyseState.ftp_amphitech') },
		'asts0': { label: i18next.t('analyseState.ftp_amphitech') },
		'aspr1': { label: i18next.t('analyseState.ftp_provider') },
		'aspr0': { label: i18next.t('analyseState.ftp_provider') }
	};

	_.each(schema, (type, index) => {
		result[type].type = type;
		if (octalList[index]) {
			result[type].state = parseInt(octalList[index], 2);
			result[type].stateLabel = STATE_TABLE[result[type].state].text;
		} else {
			result[type].state = 0;
			result[type].stateLabel = STATE_TABLE[result[type].state].text;
		}
	})

	return result;
}


export function analyseState2(fiche, site_state) {

	var label = '';
	var warning = false;
	var sens_interdit = false;
	var color;
	var error = false

	var green = "#00FF00"
	var orange = "orange"
	var blue = "#0000FF"



	if (site_state != null) {

		var asts1_state = site_state.asts1.state;
		var asts0_state = site_state.asts0.state;

		//AMPHITECH 0 PRES 0
		if (fiche.etat_FTP == 1 || fiche.etat_FTP == 3) {
			color = blue
			label = i18next.t('analyseState.sheet_synced')

			if (asts0_state > 3) {
				error = i18next.t('analyseState.deactivation_failed')+ getError(asts0_state);
				warning = true;
			}

			else if (asts1_state > 3) {
				error = i18next.t('analyseState.activation_failed') + getError(asts1_state);
				warning = true;
			}

			if (fiche.etat_en_service == 1 && fiche.etat_telealarme == 1 && fiche.etat_telesurveillance == 1 && fiche.etat_supervision == 1) {
				color = green
				/*warning = false;*/
				label = i18next.t('analyseState.sheet_activated')
			} else {
				//error = "Anomalie détectée, veuillez verifier la supervision du produit";
				//warning = true;
			}




		} else if (fiche.etat_FTP == 2) {
			color = blue
			sens_interdit = true
			label = i18next.t('analyseState.sheet_indispo')


			if (asts1_state > 3) {
				error = i18next.t('analyseState.activation_error')+ getError(asts1_state);
				color = orange;
				sens_interdit = true;
			}

			if (asts0_state > 3) {
				error = i18next.t('analyseState.deactivation_failed') + getError(asts0_state);
				warning = true;
			}

			if (fiche.etat_en_service == 1 && fiche.etat_telealarme == 1 && fiche.etat_telesurveillance == 1 && fiche.etat_supervision == 1) {
				color = 'red'
			}


		} else if (fiche.etat_FTP == null || fiche.etat_FTP == 0) {
			color = "orange";
		}

		if (fiche.etat_indisponibilite_sts == 1) {
			color = 'red';
			label = i18next.t('analyseState.sheet_indispo')
		}


		return { color, label, warning, sens_interdit, error }



		/*if( fiche.etat_en_panne != 0) {
			color = 'white'
			label = 'En panne'
			return {color, label, warning, sens_interdit}
			
		} else *//*if( fiche.etat_en_travaux != 0) {
			color = 'yellow'
			label = 'En travaux'
			
			return {color, label, warning, sens_interdit}
			
		}
		
		
		if( asts1_state > 3 ) { //Erreur d'activation, asts0 vaut 0 ou 3
			warning = true
			if( asts0_state == 3 ) {//reactivation échouée
				color = "#0000FF"; 
				label = "Réactivation échouée";
				
				if( fiche.etat_en_service == 1 ) {
					color = 'red'//'#00FF00'; 
				}
				
				
			} else {//1ere activation échouée
				color = "orange";
				label = "Erreur d'activation";
				
				if( fiche.etat_en_service == 1 ) {
					color = '#00FF00';
				}
				
			}
			
			if( fiche.etat_indisponibilite_sts ) {
				color = 'red';
			}
			
			var error = getError(asts1_state);
				
			label = label + ' ' +error; 
		
			return {color, label, warning, sens_interdit}
			
		} else if (asts0_state > 3 ) {// Désactivation échouée, asts1 vaut toujours 3 à ce moment
			
			var error = getError(asts0_state);
			
			color = '#0000FF';
			warning = true;
			label = "Désactivation échouée";
			
			
			if( fiche.etat_en_service == 1 ) {
				color = '#00FF00'; 
			}
			
			if( fiche.etat_indisponibilite_sts ) {
				color = 'red';
			}
			
			label = label + ' ' +error; 
			
			return {color, label, warning, sens_interdit}
		}
		
		
		
		if( asts1_state == 3 ) { //FTP activé asts0 à 0
			color = '#0000FF';//bleu
			label = "Fiche synchronisée";
			
			if( fiche.etat_en_service == 1 ) {
				
				color = '#00FF00';
				label = "Fiche activée";
			}
			
			
			if( fiche.etat_indisponibilite_sts ) {
				color = 'red';
			}
			
			
			
		} else if(asts0_state == 3) {
			color = "#0000FF";
			label = "Fiche désactivée"
			sens_interdit = true
			
			if( fiche.etat_en_service == 1 ) {
				color = 'red' //'#00FF00';
				sens_interdit = false; 
				warning = false;
			} else {
				color = 'red'  
			}
			
			if( fiche.etat_indisponibilite_sts ) {
				color = 'red';
			}
			
			
		}
		
		else if( asts1_state == 0 && asts0_state == 0 ) {
			color = 'orange';
			//label = "Fiche désactivée"
			label = ""
				
				
				
		}
		
		return {color, label, warning, sens_interdit}
		
	}
	*/
	}

}


export function getError(state) {

	var error = '';
	if (state == 4) {
		error = i18next.t('analyseState.ptu_id_error');
	} else if (state == 5) {
		error = i18next.t('analyseState.timeout_p_not_respond');
	}
	else if (state == 6) {
		error = i18next.t('analyseState.api_sms_error');
	}
	else if (state == 7) {
		error = i18next.t('analyseState.ftp_provider_error');
	}

	return error

}


export function isActivated(fiche) {
	var site_state = analyseState(fiche.s_etat);
	var asts1_state = site_state.asts1.state;
	var asts0_state = site_state.asts0.state;

	if (asts0_state == 3) {
		return false
	} else if (asts1_state == 3) {
		return true
	}
}


export function generateStateColumn(fiche) {

	var color;
	var warning = false;
	var sens_interdit = false;
	var error = ''

	var label = []

	var site_state = analyseState(fiche.s_etat);

	if (
		!fiche.identification_GSM
		|| !fiche.localisation_adresse
		|| !fiche.identification_ID
		|| !fiche.identification_NUM_MOD
		|| !fiche.identification_NUM_ASC
	) {
		color = 'black';
		label = ''
	} else {
		var obj = analyseState2(fiche, site_state)
		color = obj.color;
		warning = obj.warning;
		sens_interdit = obj.sens_interdit;
		label = obj.label;
		error = obj.error
	}

	var tooltip = <Tooltip id="tooltip">{label}</Tooltip>

	var tooltipError = <Tooltip id="tooltip">{error}</Tooltip>


	var circleLabel = label

	if (color == 'orange') {
		circleLabel = i18next.t('analyseState.filled_no_sync')
	} else if (color == "black") {
		circleLabel = i18next.t('analyseState.not_filled_orange')
	}
	var circleTooltip = <Tooltip id="tooltip">{circleLabel}</Tooltip>
	var circle = <OverlayTrigger placement="top" overlay={circleTooltip}><i className="fa fa-circle" style={{ "color": color }} /></OverlayTrigger>

	//var circle = <i className="fa fa-circle" style={{"color":color}}/> 

	var wbutton = warning ? <i style={{ color: 'red' }} className="fa fa-warning" /> : ''
	var sbutton = sens_interdit ? <i style={{ color: 'red' }} className="fa fa-minus-circle" /> : ''


	if (error) {
		wbutton = <OverlayTrigger placement="top" overlay={tooltipError}><span>{wbutton}</span></OverlayTrigger>
		sbutton = <OverlayTrigger placement="top" overlay={tooltipError}><span>{sbutton}</span></OverlayTrigger>
	}

	return (<span>{circle} {wbutton} {sbutton}</span>)

}




// Version texte de generateStateColumn (les tooltips ne sont pas utilisables au tactile)
export function getStateSummary(fiche) {
	if (
		!fiche.identification_GSM
		|| !fiche.localisation_adresse
		|| !fiche.identification_ID
		|| !fiche.identification_NUM_MOD
		|| !fiche.identification_NUM_ASC
	) {
		return { color: 'black', label: i18next.t('analyseState.not_filled_orange'), warning: false, sens_interdit: false, error: '' }
	}

	var obj = analyseState2(fiche, analyseState(fiche.s_etat))
	return { ...obj, label: obj.color == 'orange' ? i18next.t('analyseState.filled_no_sync') : obj.label }
}


export function createStateColumn(fiche) {

	var color;
	var site_state = analyseState(fiche.s_etat);
	if (!fiche.identification_GSM
		|| !fiche.localisation_adresse
		|| !fiche.identification_ID
		|| !fiche.identification_NUM_MOD

	) {
		color = 'a';
	} else {

		var obj = analyseState2(fiche, site_state)
		color = obj.color;
		if (color == 'orange') {
			color = 'b'
		} else if (color == 'black') {
			color = 'a'

		} else if (color == '#0000FF') {
			color = 'c'

		} else if (color == '#00FF00') {
			color = 'd'

		} else if (color == 'red') {
			color = 'e'

		}

	}
	return color
}
